import { FunctionComponent, h } from 'preact';
import classNames from 'classnames';

import poweredByLogo from '../../assets/powered-by-reverse.svg';

interface Props {
	className?: string;
}
const PoweredByFooter: FunctionComponent<Props> = ({ className }) => {
	return (
		<div className={classNames('powered-by-footer', className)} data-testid="powered-by-footer">
			<div className="divider" />
			<img className="powered-by-logo" src={poweredByLogo} alt="powered by bringg" />
		</div>
	);
};

export default PoweredByFooter;
